import { organizationStore } from "../stores";

export const useOrganizationStore = () => organizationStore;
